<template>
<div>
    <div class="row">
        <div class="col-md-12 ">
            <ExtentList @checkChange="handleCheckChangeParent" />
        </div>
    </div>
    <span v-if="permissions.includes('SELECT_EXTENT')" style="margin-right:15px;margin-bottom:20px">
           View<el-switch v-model="edit_mode" style='margin-left:5px;margin-right:5px'></el-switch>Edit
    </span>
    <div style="margin-top:20px;" v-if="!edit_mode">
       <ol>
         <li style="font-size:20px;" v-for="sentence in sentences">
           <div v-if="!sentence.rule.asset_filter">
              THIS IS A LEGACY RULE. You can only see this rule in edit view.
           </div>
           <div v-else>
             When <strong>{{sentence.rule.asset_filter.name}}</strong> then
             <span v-if="sentence.rule.asset_filter.name!==sentence.rule.bucket">
              we consider it <strong>{{sentence.rule.bucket}}</strong> and
           </span>
             <span v-if="sentence.rule.resourcing==='TBD'">
             we
           </span>
             <span v-else>
             <strong>{{sentence.rule.resourcing}}</strong>
           </span>
             will <strong>{{sentence.rule.disposition}}</strong>.
           </div>
         </li>
       </ol>
    </div>
    <div v-else-if="extent_state==='archived'" style="background-color:#FFE98A;padding:10px;margin-bottom:20px;">
        You cannot add, manage, or run rules with an archived extent.
    </div>
    <div v-else style="margin-top:20px;">

        <el-button type="primary" @click="add_blank_rule()">Add a Rule</el-button>
        <el-button type="info" @click="run_ruleset()">Run this ruleset</el-button>
        <el-button type="info" @click="go_to_dispositions()">Dispositions</el-button>
        <el-dialog
                :title="editing_label"
                :visible.sync="editing_cell_modal">
            <div>{{editing_instructions}}</div>
          <div style="margin-top:20px;" v-if="active_edit_cell.header_name == 'disposition'" >
            Unstructured<el-switch style="margin-left: 10px; margin-right: 10px;" v-model="disposition_type_is_structured"></el-switch>Structured
            <div v-if="disposition_type_is_structured" style="margin-top:10px;">
              <div>
                <el-radio v-model="disposition_type" label="used">Already Used</el-radio>
                <el-radio v-model="disposition_type" label="custom">Custom Defined</el-radio>
                <el-radio v-model="disposition_type" label="standard">Standard (from Dispositions DB)</el-radio>
              </div>
              <el-select v-model="selected_disposition_id" placeholder="Select" style="margin-top: 10px;margin-bottom:10px;">
                <el-option
                    v-for="disposition in dispositions_for_select"
                    :key="disposition.id"
                    :label="disposition.title"
                    :value="disposition.id">
                </el-option>
              </el-select>
            </div>
            <div v-else>
              <el-input @keyup.enter.native="cell_change" placeholder="new value" v-model="cell_input" autofocus="true"></el-input>
            </div>
          </div>
            <div v-else>
              <el-input @keyup.enter.native="cell_change" placeholder="new value" v-model="cell_input" autofocus="true"></el-input>
            </div>
          <div style="margin-top:10px;">
            <el-button  @click="cell_change()">Save</el-button>
            <el-button  @click="unselect_current_cell()">Cancel</el-button>
          </div>
        </el-dialog>
        <el-dialog
            title="Edit Filter"
            :visible.sync="show_edit_filter"
            width="75%"
        >
            <filter-edit
                    :asset_filter_id="currently_editing_filter_id"
                    :extent_id="extent_id"
                    @filterSaved="handleFilterSaved"
            ></filter-edit>

        </el-dialog>

        <el-table-draggable handle=".draggable" @drop="handleReorder">
            <el-table
                    :data="array_data"
                    style="width: 100%">
                    <el-table-column
                        v-for = "column in columns"
                        v-bind:label = column.label
                        v-bind:prop = column.prop
                        v-bind:width = column.width
                    >
                        <template slot-scope="scope">
                            <div class="draggable">
                                <span v-if="column.prop.toLowerCase() === 'rule_id'">
                                    <el-button type="link" @click="delete_row(scope.row.id)" icon="el-icon-delete"></el-button>
                                </span>
                                <span v-else-if="column.prop.toLowerCase() === 'filter_name'">
                                    <el-button  class="ss-button" @click="edit_filter(scope.row.id,scope.row['asset_filter_id'])">
                                      <span v-if="scope.row['asset_filter']">
                                         {{ scope.row['asset_filter']['name'] }}
                                      </span>
                                      <span v-else>
                                        (empty)
                                      </span>
                                    </el-button>
                                </span>
                                <span v-else-if="column.prop.toLowerCase() === 'order'">
                                    <el-button @click="setEditableInplace(scope.row.id, column.prop,scope.row[column.prop])"><i class="el-icon-sort"></i>{{ scope.row[column.prop] }}</el-button>
                                </span>
                                <el-button v-else   class="ss-button" @click="setEditableModal(scope.row.id, column.prop,scope.row[column.prop],scope.row.disposition_id)">{{ scope.row[column.prop] }}</el-button>
                            </div>

                        </template>
                    </el-table-column>
            </el-table>
        </el-table-draggable>
    </div>
</div>
</template>

<script>
import ElTableDraggable from 'element-ui-el-table-draggable';
    export default {
        props: ['ruleset_id'],
        mounted() {
            // console.log('Component mounted now.')
            this.permissions = chimera.permissions
        },
        watch: {
            extent_id: function (newValue, oldValue) {
                this.load_data()
                this.getSentences()
                this.getDispositions()
            },
            ruleset_id: function (newValue, oldValue) {
                this.trigger_flatten()
            },
            edit_mode: function() {
                if (!this.edit_mode) this.getSentences()
            }
        },
        computed: {
            dispositions_for_select: function() {
              if (this.disposition_type==='used') {
                return this.dispositions.used.by_extent_rules
              } else if (this.disposition_type==='custom') {
                return this.dispositions.available.defined_for_extent
              } else if (this.disposition_type==='standard') {
                return this.dispositions.available.dispositions_db
              } else {
                return null
              }
            },
            editing_label: function () {
                let label = "value"
                if (this.active_edit_cell.header_name == "disposition") {
                    label = "value";
                } else if (this.active_edit_cell.header_name == "order"
                    || this.active_edit_cell.header_name == "rule_id"
                    || this.active_edit_cell.header_name == "name"
                    || this.active_edit_cell.header_name == "bucket"
                    || this.active_edit_cell.header_name == "resourcing") {
                    label = "value";
                } else {
                    label = "rule"
                }
                return "Edit " + label + " for " + this.active_edit_cell.header_name
            },
            editing_instructions: function () {
                if (this.active_edit_cell.header_name == "disposition") {
                    return "In general, use structured dispositions! These allow you to estimate effort.";
                } else if (this.active_edit_cell.header_name == "order"
                    || this.active_edit_cell.header_name == "rule_id"
                    || this.active_edit_cell.header_name == "name"
                    || this.active_edit_cell.header_name == "bucket"
                    || this.active_edit_cell.header_name == "resourcing") {
                    return "";
                } else {
                    return "The first character must be an operator to compare the value of this field to the rule. Valid operators are: =, <, >, and ∅ (to indicate field must be empty). Advanced operator is / (to indicate the start of a regular expression)";
                }
            },
            dispositions_list: function () {
                let list = ""
                let first = true
                console.log(this.dispositions)
                console.log(this.dispositions.length)
                if (this.dispositions.length > 0) {
                    console.log("we have dispositions")
                    list = "Consider using one of these standard dispositions: "
                    this.dispositions.forEach((disposition, index) => {
                        if (first) first = false
                        else list = list + ", "
                        list = list + disposition.slug
                    })
                } else {
                    console.log("we do NOT have dispositions")
                }
                return list
            }
        },
        data() {
            return {
                selected_disposition_id: null,
                disposition_type: 'used',
                disposition_type_is_structured: true,
                permissions: null,
                edit_mode: false,
                sentences: [],
                show_edit_filter: false,
                currently_editing_filter_id: null,
                counter: 0,
                columns: [
                    {prop: 'order', label:'', width: 80},
                    {prop: 'filter_name', label: 'Filter'},
                    {prop: 'bucket', label: 'Bucket'},
                    {prop: 'disposition', label: 'Disposition'},
                    {prop: 'resourcing', label: 'Resourcing'},
                    {prop: 'rule_id', label:'', width: 70},
                ],
                array_data:[],
                active_edit_cell: {rule_id: null, header_name: null, new_value: null},
                cell_input: '',
                editing_cell_modal: false,
                editing_cell_inplace: false,
                available_fields: '',
                selected_new_field: '',
                show_new_field_overlay: false,
                extent_id: null,
                dispositions: [],
                extent_state: '',
        }},
        components: {ElTableDraggable},
        methods: {
            getSentences() {
              axios.get('/api/sentences/' + this.extent_id)
                  .then(response => {
                    this.sentences = response.data
                  })
                  .catch(error => {
                    console.log('oops getting sentences')
                  })
            },
            handleReorder() {
                console.log(this.array_data)
                axios.patch('/api/rules/' + this.extent_id, {
                    ordered: this.array_data
                }).then(response => {
                    this.load_data()
                }).catch(error => {
                    console.log('oops row move problem')
                    console.log(error)
                })
            },
            handleFilterSaved(asset_filter) {
                console.log('in handleFilterSaved')
                axios.patch('/api/rules/set_filter/' + this.extent_id + '/' + this.active_edit_cell.rule_id, {
                    asset_filter_id: asset_filter.id
                }).then(response => {
                    this.load_data()
                }).catch(error => {
                    console.log('oops row move problem')
                    console.log(error)
                })
                this.load_data()
                this.show_edit_filter = false
            },
            edit_filter(rule_id,filter_id) {
                console.log(filter_id)
                this.currently_editing_filter_id = filter_id
                this.show_edit_filter = true
                this.active_edit_cell.rule_id = rule_id
            },
            add_blank_rule() {
                axios.post('/api/rules/add/' + this.extent_id, {
                }).then(response => {
                    console.log('added rule')
                    this.load_data()
                }).catch(error => {
                    console.log('oops adding rule')
                    console.log(response)
                })
            },
            load_data() {
                axios.get('/api/rules/' + this.extent_id)
                    .then(response => {
                        this.array_data = response.data
                        // console.log(this.array_data)
                    })
                    .catch(error => {
                        console.log('oops table data')
                    })
            },
            listener() {
                // console.log('listen')
            },
            setEditableModal(rule_id, header_name, current_value,disposition_id) {
                console.log('disposition_id is ' + disposition_id)
              console.log('header_name is ' + header_name)
              this.selected_disposition_id = disposition_id

              if (disposition_id) {
                  this.disposition_type_is_structured = true
                } else {
                  this.disposition_type_is_structured = false
                }
                this.cell_input = current_value
                this.active_edit_cell.rule_id = rule_id
                this.active_edit_cell.header_name = header_name
                this.editing_cell_modal = true
            },
            setEditableInplace(rule_id, header_name, current_value) {
                this.cell_input = current_value
                this.active_edit_cell.rule_id = rule_id
                this.active_edit_cell.header_name = header_name
                this.editing_cell_inplace = true
            },
            delete_row(rule_id) {
                // console.log(this.ruleset_id)
                // console.log(rule_id)
                axios.delete('/api/rules/' + this.extent_id + '/' + rule_id, {
                }).then(response => {
                    // console.log(response)
                    this.load_data()
                }).catch(error => {
                    console.log('oops deleting row')
                    console.log(error)
                })
            },
            go_to_dispositions() {
              window.open("/dispositions/" + this.extent_id,"_blank")
            },
            run_ruleset() {
                axios.post('/api/jobChains', {
                    extent_id: this.extent_id,
                    type: "assign"
                }).then(response => {
                    // console.log(response)
//                    window.location.href = '/progress/'
                    // need to come back so that we pass the job chain to progress
                    window.location.href = '/progress/' + response.data.job_chain_id
                }).catch(error => {
                    console.log('oops starting job chain')
                    console.log(error)
                })
            },
            move_row(rule_id) {
                axios.patch('/api/flattened/' + this.ruleset_id + '/' + rule_id, {
                    new_position: this.cell_input
                }).then(response => {
                    // console.log('successfully moved row')
                    // console.log(response)
                    this.unselect_current_cell()
                    this.load_data()
                }).catch(error => {
                    console.log('oops row move problem')
                    console.log(response)
                    })
            },
            unselect_current_cell() {
                this.active_edit_cell.rule_id = null
                this.active_edit_cell.header_name = null
                this.cell_input = null
                this.editing_cell_modal = false
                this.editing_cell_inplace = false
            },
            cell_change() {
                // console.log("in cell_change()")
                if (this.header_name == 'order') {
                    // change order
                    // console.log("about to change the order")
                } else {
                    // change cell value
                    // console.log("changing something other than the order")
                    axios.patch('/api/rules/' + this.extent_id + '/' + this.active_edit_cell.rule_id + '/' + this.active_edit_cell.header_name, {
                        new_value: this.cell_input,
                        disposition_id: this.selected_disposition_id
                    }).then(response => {
                        this.load_data()
                        this.unselect_current_cell()
                        // console.log(response)
                    })
                }
                this.editing_cell_modal = false
                this.editing_cell_inplace = false
            },
            handleCheckChangeParent(selected_extent) {
                this.extent_id = selected_extent.id
                this.extent_state = selected_extent.state
                this.load_data()
            },
            getDispositions() {
              axios.get('/api/dispositions/' + this.extent_id)
                  .then(response => {
                    this.dispositions = response.data
                    console.log(this.dispositions)
                    if (this.dispositions.used.by_extent_rules.length>1) {

                    }
                  })
                  .catch(error => {
                    console.log('oops getting existing dispositions')
                  })
            },
        }
    }
</script>
